import store from 'store';

export const authenticationService = {
    get currentUserValue() {
        return store.getState().auth.user;
    },
};
